import styles from "./ResultPrice.module.css";
import axios from "axios";
import { ErrorModal } from "../UI/ErrorModal";
import domtoimage from "dom-to-image-more";
import { useEffect, useRef, useState } from "react";

export function ResultPrice(props) {
  const [frontImage, setFrontImage] = useState();
  const [rearImage, setRearImage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const notification = document.querySelector(".notification");
  notification.textContent = "Plate is updated";
  const wrapperRef = useRef(null);
  const childRef = useRef(null);
  const [isFixed, setIsFixed] = useState(true);
  const currentUrl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname;
  const searchParams = new URLSearchParams(document.location.search);

  useEffect(() => {
    const hasFrontImage = props.choosedOptions.frontPlate !== "false";
    const hasRearImage = props.choosedOptions.rearPlate !== "false";
    const hasTwoImage = hasRearImage && hasFrontImage;
    const reg = /^(?:[A-Z]{2}[0-9]{2}|[A-Z][0-9]{2})\s?[A-Z]{3}$/;
    let condition = false;
    if (hasTwoImage) {
      condition = frontImage?.length > 0 && rearImage?.length > 0;
    } else if (hasFrontImage) {
      condition = frontImage?.length;
    } else if (hasRearImage) {
      condition = rearImage?.length > 0;
    }
    
    if (condition) {
      if (
        props.choosedOptions.categoryPlate.includes("standard") &&
        (
          props.choosedOptions.registrationName.length < 7 ||
          props.choosedOptions.registrationName.length > 8 ||
          (!reg.test(props.choosedOptions.registrationName) ||
          !/^[A-Z]{3}$/.test(props.choosedOptions.registrationName.slice(-3)))
        ) &&
        props.choosedOptions.registrationName.length !== 0
      ) {
        
        props.checkValid({
          isValid: false,
          typePlate: "standard",
        });
      } else if (props.choosedOptions.registrationName.length === 0) {
        props.isDefaultName(false);
        props.checkValid({
          isValid: false,
          typePlate: "empty-name",
        });
      } else {
        if (searchParams.get("plateMaterial") === "null") {
          searchParams.set("plateMaterial", "Regular");
        }
        if (searchParams.get("fontStyle") === "null") {
          searchParams.set("fontStyle", "CharlesWright Bold");
        }
        if (
          searchParams.get("plateSizeFront") === "null" &&
          searchParams.get("typeOfTransport") === "car"
        ) {
          searchParams.set(
            "plateSizeFront",
            "Standard Car Oblong (20.5x4.4in)"
          );
        } else if (
          searchParams.get("plateSizeFront") === "null" &&
          searchParams.get("typeOfTransport") === "motorbike"
        ) {
          searchParams.set("plateSizeFront", "Standard Motorcycle (9x7in)");
        }
        if (
          searchParams.get("plateSizeRear") === "null" &&
          searchParams.get("typeOfTransport") === "car"
        ) {
          searchParams.set("plateSizeRear", "Standard Car Oblong (20.5x4.4in)");
        } else if (
          searchParams.get("plateSizeRear") === "null" &&
          searchParams.get("typeOfTransport") === "motorbike"
        ) {
          searchParams.set("plateSizeRear", "Standard Motorcycle (9x7in)");
        }
        if (searchParams.get("frontPlate") === "false") {
          searchParams.delete("plateSizeFront");
          searchParams.delete("frontPrice");
        }
        if (searchParams.get("rearPlate") === "false") {
          searchParams.delete("plateSizeRear");
          searchParams.delete("rearPrice");
        }
        if (
          searchParams.get("plateMaterial") === "Black" ||
          searchParams.get("plateMaterial") === "Silver" ||
          searchParams.get("plateMaterial") === "Silver Mirror" ||
          searchParams.get("plateMaterial") === "Pressed Metal Black" ||
          searchParams.get("plateMaterial") === "Pressed Metal"
        ) {
          searchParams.delete("badgeRight");
          searchParams.delete("badgeColorRight");
          searchParams.delete("badgeRightName");
          searchParams.delete("badgeLeft");
          searchParams.delete("badgeColorLeft");
          searchParams.delete("badgeLeftName");
          searchParams.delete("hasCustomBadgeLeft");
          searchParams.delete("hasCustomBadgeRight");
          searchParams.delete("customBadgeImageLeft");
          searchParams.delete("customBadgeImageRight");
          searchParams.delete("customBadgeTextLeft");
          searchParams.delete("customBadgeTextRight");
          searchParams.delete("customBadgeTextColorLeft");
          searchParams.delete("customBadgeTextColorRight");
          searchParams.delete("customBadgeRotationLeft");
          searchParams.delete("customBadgeRotationRight");
          searchParams.delete("borderWidth");
          searchParams.delete("borderColor");
          searchParams.delete("sloganName");
          searchParams.delete("sloganFont");
          searchParams.delete("sloganStyle");
          searchParams.delete("sloganColor");
        }

        window.history.replaceState(
          "",
          "",
          currentUrl + "?" + searchParams.toString()
        );
        // searchParams.set('frontPlateImg', frontImage)
        // searchParams.set('rearPlateImg', rearImage)

        const optionsPrams = Object.fromEntries(searchParams);
        optionsPrams.frontPlateImg = frontImage;
        optionsPrams.rearPlateImg = rearImage;

        const data = {
          action: "add_plate_product",
          options: optionsPrams,
        };
        document
          .querySelector(".plate-builder__wrapper")
          .classList.add("loading");
        axios
          .post(numberplate.ajax_url, data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((res) => {
            // searchParams.delete('frontPlateImg')
            // searchParams.delete('rearPlateImg')
            setFrontImage("");
            setRearImage("");
            if (
              props.choosedOptions.rearId !== "null" ||
              props.choosedOptions.frontId !== "null"
            ) {
              document
                .querySelector(".plate-builder__wrapper")
                .classList.remove("loading");
              notification.classList.remove("disabled");
              setTimeout(function () {
                notification.classList.add("disabled");
              }, 3000);
            } else {
              window.location.href = res.data.redirect;
            }
            window.location.href = res.data.redirect;
          });
      }
    }
  }, [frontImage, rearImage]);

  const filterParams = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const reg = /^(?:[A-Z]{2}[0-9]{2}|[A-Z][0-9]{2})\s?[A-Z]{3}$/;

    if (
      props.choosedOptions.categoryPlate.includes("standard") &&
      (
        props.choosedOptions.registrationName.length < 7 ||
        props.choosedOptions.registrationName.length > 8 ||
        (!reg.test(props.choosedOptions.registrationName) ||
        !/^[A-Z]{3}$/.test(props.choosedOptions.registrationName.slice(-3)))
      ) &&
      props.choosedOptions.registrationName.length !== 0
    ) {
      props.checkValid({
        isValid: false,
        typePlate: "standard",
      });
      setIsLoading(false);
    } else if (props.choosedOptions.registrationName.length === 0) {
      props.isDefaultName(false);
      props.checkValid({
        isValid: false,
        typePlate: "empty-name",
      });
      setIsLoading(false);
    } else {
      buildImage();
    }
  };

  const waitForImages = async (element) => {
    if(element) {
      const images = element.querySelectorAll("img")
      return Promise.all(
          [...images].map((img) => {
            return new Promise((resolve) => {
              if (img.complete) resolve();
              else img.onload = img.onerror = resolve;
            });
          })
      )
    }
  };
  

  const buildImage = () => {
    const hiddenBlock = document.querySelector(".hidden-block");
    let frontImage, rearImage;
    if (document.getElementById("rear-plate")) {
      const rearImageСlone = document
        .getElementById("rear-plate")
        .cloneNode(true);
      hiddenBlock.append(rearImageСlone);
      rearImage = hiddenBlock.querySelector("#rear-plate");
      rearImage.style.width = rearImage.offsetWidth * 3 + "px";
      rearImage.style.height = rearImage.offsetHeight * 3 + "px";
    }

    if (document.getElementById("front-plate")) {
      const frontImageСlone = document
        .getElementById("front-plate")
        .cloneNode(true);
      hiddenBlock.append(frontImageСlone);
      frontImage = hiddenBlock.querySelector("#front-plate");
      frontImage.style.width = frontImage.offsetWidth * 3 + "px";
      frontImage.style.height = frontImage.offsetHeight * 3 + "px";
    }

    if (props.choosedOptions.frontPlate === "true") {
      const frontHeight = frontImage.clientHeight;
      const frontWidth = frontImage.clientWidth;
      waitForImages(frontImage).then(() => {
        domtoimage
          .toPng(frontImage, {
            imageTimeout: 1000,
            quality: 1,
            width: frontWidth,
            height: frontHeight,
            style: {
              transform: "scale(1)",
              transformOrigin: "top left",
              width: `${frontWidth}px`,
              height: `${frontHeight}px`,
            },
          })
          .then(function (dataUrl) {
            setFrontImage(dataUrl);
          })
          .then(function () {
            document.querySelector(".hidden-block #front-plate").remove();
          })
          .catch(function (error) {
            console.error("oops, something went wrong!", error);
          });
      });
    }

    if (props.choosedOptions.rearPlate === "true") {
      const rearHeight = rearImage.clientHeight;
      const rearWidth = rearImage.clientWidth;
      waitForImages(rearImage).then(() => {
        domtoimage
          .toPng(rearImage, {
            width: rearWidth, 
            height: rearHeight,
            imageTimeout: 1000,
            quality: 1,
            style: {
              transform: "scale(1)", 
              transformOrigin: "top left",
              width: `${rearWidth}px`,
              height: `${rearHeight}px`,
            },
          })
          .then(function (dataUrl) {
            setRearImage(dataUrl);
          })
          .then(function () {
            document.querySelector(".hidden-block #rear-plate").remove();
          })
          .catch(function (error) {
            console.error("oops, something went wrong!", error);
          });
      });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (wrapperRef.current && childRef.current && window.innerWidth < 640) {
      const wrapper = wrapperRef.current;
      const child = childRef.current;

      child.classList.add("fixed");
      wrapper.style.height = `${child.clientHeight}px`;

      const handleScroll = () => {
        const wrapperRect = wrapper.getBoundingClientRect();
        if (wrapperRect.top - window.innerHeight + wrapper.clientHeight < 0) {
          setIsFixed(false);
        } else {
          setIsFixed(true);
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return (
    <>
      {!props.isValid.isValid && (
        <ErrorModal
          updateChoosedOptions={props.updateChoosedOptions}
          addFocus={props.addFocus}
          choosedOptions={props.choosedOptions}
          list={props.isValid.list}
          closeModal={props.checkValid}
          messageType={props.isValid.typePlate}
        ></ErrorModal>
      )}
      <div ref={wrapperRef} className="sticky-result">
        <div
          ref={childRef}
          className={
            styles["result-price"] +
            " flex items-center justify-between" +
            `${isFixed ? " result-price fixed" : ""}`
          }
        >
          <div className={styles["result-price__price-wrapper"]}>
            TOTAL PRICE
            {props.choosedOptions.frontPlate === "false" &&
              props.choosedOptions.rearPlate === "true" && (
                <span className={styles["result-price__price"]}>
                  £{(+props.choosedOptions.rearPrice).toFixed(2)}
                </span>
              )}
            {props.choosedOptions.frontPlate === "true" &&
              props.choosedOptions.rearPlate === "false" && (
                <span className={styles["result-price__price"]}>
                  £{(+props.choosedOptions.frontPrice).toFixed(2)}
                </span>
              )}
            {props.choosedOptions.frontPlate === "true" &&
              props.choosedOptions.rearPlate === "true" && (
                <span className={styles["result-price__price"]}>
                  £
                  {(
                    +props.choosedOptions.frontPrice +
                    +props.choosedOptions.rearPrice
                  ).toFixed(2)}
                </span>
              )}
          </div>
          <div className={styles["result-price__btn-wrapper"]}>
            <button
              disabled={isLoading}
              onClick={filterParams}
              className={styles["result-price__btn"] + " btn btn--orange"}
            >
              {props.choosedOptions.rearId !== "null" ||
              props.choosedOptions.frontId !== "null"
                ? "UPDATE PLATE"
                : "ADD TO CART"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
